import {useCallback, useMemo, useState} from "react";

// Selection state for the "move media" tool on the gallery detail page.
// Tracks selected photo and video ids independently while in select mode.
export function useSelection() {
  const [selectMode, setSelectMode] = useState(false)
  const [selectedPhotos, setSelectedPhotos] = useState<Set<number>>(new Set())
  const [selectedVideos, setSelectedVideos] = useState<Set<number>>(new Set())

  const toggleIn = (set: (fn: (prev: Set<number>) => Set<number>) => void) => (id: number) => {
    set(prev => {
      const next = new Set(prev)
      if (next.has(id)) next.delete(id); else next.add(id)
      return next
    })
  }

  const togglePhoto = useCallback(toggleIn(setSelectedPhotos), [])
  const toggleVideo = useCallback(toggleIn(setSelectedVideos), [])

  const clear = useCallback(() => {
    setSelectedPhotos(new Set())
    setSelectedVideos(new Set())
    setSelectMode(false)
  }, [])

  const count = selectedPhotos.size + selectedVideos.size

  return {
    selectMode, setSelectMode,
    selectedPhotos, selectedVideos,
    togglePhoto, toggleVideo,
    clear, count,
  }
}

export type Selection = ReturnType<typeof useSelection>
